import React, { FC } from 'react';
import { Controller, useFormContext } from 'react-hook-form';

import { ButtonToggles } from '@eika/radio-button';

import { ValgtWeb } from '../../generated-types';
import { useTranslation } from '../../translations';
import { TilbakemeldingFormData } from './kvittering';

const TilbakemeldingValg: FC = () => {
    const { kvittering, button } = useTranslation();
    const { control } = useFormContext<TilbakemeldingFormData>();

    return (
        <Controller
            name="tilbakemeldingValg"
            control={control}
            render={({ field: { value, onChange } }) => (
                <ButtonToggles
                    label={kvittering.togglesTilbakemelding}
                    data-track-id="kreditt-boliglaan-tilbakemelding-valg-gi-tilbakemelding"
                    data-track-linkname={value}
                    onChange={(value) => onChange(value as ValgtWeb)}
                    selectedOption={value}
                    options={[
                        { label: button.ja, value: ValgtWeb.JA },
                        { label: button.nei, value: ValgtWeb.NEI },
                    ]}
                />
            )}
        />
    );
};

export default TilbakemeldingValg;
